import { render, staticRenderFns } from "./VariantSelector.vue?vue&type=template&id=642ae71a&scoped=true"
import script from "./VariantSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./VariantSelector.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./VariantSelector.vue?vue&type=style&index=0&id=642ae71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ae71a",
  null
  
)

export default component.exports